module.exports = __webpack_public_path__ + "img/CATEGORY ICON-21.72f459f8.png";